<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import getInitials from '@/helpers/get-initials'
import api from '@/helpers/api'

export default {
  name: 'sales.customers.view-customer',
  page: {
    title: 'Sales - Customer',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  props: {
    customer_id: { type: String, required: true }
  },
  data: () => ({
    isLoading: false,
    customer: {
      billing_address: {}
    }
  }),
  mounted () {
    this.onInit()
  },
  watch: {
    customer_id: 'onInit'
  },
  methods: {
    async onInit () {
      this.isLoading = true
      let item = await api.customers.fetch({
        id: this.customer_id
      })
      this.customer = { ...item, initials: getInitials(item.legal_name) }
      this.isLoading = false
    }
  },
  computed: {
    title () {
      return this.customer.legal_name || 'loading'
    },
    breadcrumbs () {
      return [
        {
          text: 'Sales',
          to: { name: 'sales' }
        },
        {
          text: 'Customers',
          to: { name: 'sales.customers' }
        },
        {
          text: this.customer.legal_name
            ? `${this.customer.legal_name}`
            : 'loading',
          active: true
        }
      ]
    }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :items="breadcrumbs">
      <template v-slot:title>
        <div class="d-flex flex-column">
          <h4 class="mb-0">
            {{ title }}
            <router-link
              v-b-tooltip.hover.top
              title="Settings"
              class="ml-4 align-middle"
              :to="{
                name: 'sales.customers.settings',
                params: { id: customer.id }
              }"
              ><i class="bx bx-cog"></i>
            </router-link>
          </h4>
          <p class="mb-0">Dashboard</p>
        </div>
      </template>
    </PageHeader>

    <h3>Customer Dashboard is Under Maintenance</h3>
    <p>Please check back in sometime.</p>

    <pre>
      todo:

      basic info
      current orders
      open invoices
      overdue invoices
      messages
      timeline?
    </pre>
    <!-- end row -->
  </Layout>
</template>
